module.exports = "<adf-card-view-arrayitem [property]=\"cardViewArrayItem\"></adf-card-view-arrayitem>\r\n"